/**
 * Machine-readable error codes returned as `code` in the error envelope.
 * Frontends switch on these; `message` is for humans and may be translated.
 */
export const ERROR_CODES = {
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    RATE_LIMITED: 'RATE_LIMITED',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
    INTEGRATION_NOT_CONFIGURED: 'INTEGRATION_NOT_CONFIGURED',
    OTP_INVALID: 'OTP_INVALID',
    OTP_EXPIRED: 'OTP_EXPIRED',
    OTP_ATTEMPTS_EXCEEDED: 'OTP_ATTEMPTS_EXCEEDED',
    OTP_RESEND_COOLDOWN: 'OTP_RESEND_COOLDOWN',
    SEATS_UNAVAILABLE: 'SEATS_UNAVAILABLE',
    RIDE_NOT_BOOKABLE: 'RIDE_NOT_BOOKABLE',
    BOOKING_NOT_CANCELLABLE: 'BOOKING_NOT_CANCELLABLE',
    PAYMENT_VERIFICATION_FAILED: 'PAYMENT_VERIFICATION_FAILED',
    DUPLICATE_REQUEST: 'DUPLICATE_REQUEST',
    TRIP_PIN_INVALID: 'TRIP_PIN_INVALID',
};
//# sourceMappingURL=errors.js.map